<div class="st-filter__header">
    <span class="st-filter__header__title">{{ viewStateFilterLabel() }}</span>
    <div class="st-filter__header__actions">
        <button
            mat-icon-button
            class="st-filter__header__actions-button"
            [matTooltip]="languageSettings.PSTWebPinFilterLabel"
            (click)="toggleFilterElevation()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-filter__header__actions-icon">
                push_pin
            </mat-icon>
        </button>
        <button
            mat-icon-button
            class="st-filter__header__actions-button"
            [matTooltip]="languageSettings.PSTWebDialogAboutCloseLabel"
            (click)="closeFilter.emit()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-filter__header__actions-icon">
                close
            </mat-icon>
        </button>
    </div>
</div>

@if (viewHasFilter()) {
    <div class="st-filter-body">
        <mat-button-toggle-group
            name="filterType"
            aria-label="Type"
            class="st-filter-full-width"
            [(ngModel)]="filterType">
            <mat-button-toggle
                class="st-filter-full-width-button-toggle"
                [value]="filterTypes.REQUIRED">
                @if (filterType === filterTypes.REQUIRED) {
                    <mat-icon class="material-symbols-outlined">check</mat-icon>
                }
                {{ languageSettings.PSTWebRequiredFiltersLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-filter-full-width-button-toggle"
                [value]="filterTypes.OPTIONAL">
                @if (filterType === filterTypes.OPTIONAL) {
                    <mat-icon class="material-symbols-outlined">check</mat-icon>
                }
                {{ languageSettings.PSTWebOptionalFiltersLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>
        @if (filterType === filterTypes.REQUIRED) {
            <st-filter-list
                [disabled]="isViewStateSortingManual()"
                [filters]="viewStateRequiredFilters()"
                [filterType]="filterTypes.REQUIRED"
                (update)="onUpdateFilter($event)"
                (adjust)="onAdjustFilter($event)"
                (remove)="onRemoveFilter($event, filterTypes.REQUIRED)" />
        }
        @if (filterType === filterTypes.OPTIONAL) {
            <st-filter-list
                [disabled]="isViewStateSortingManual()"
                [filters]="viewStateOptionalFilters()"
                [filterType]="filterTypes.OPTIONAL"
                (update)="onUpdateFilter($event)"
                (adjust)="onAdjustFilter($event)"
                (remove)="onRemoveFilter($event, filterTypes.OPTIONAL)" />
        }

        @if (filterType === filterTypes.REQUIRED) {
            <button
                mat-raised-button
                class="st-filter-add"
                [matMenuTriggerFor]="listRequiredFilterDropDownMenu"
                [disabled]="isViewStateSortingManual()">
                {{ `+ ${languageSettings.PSTWebAddFilterLabel}` }}
            </button>
            <mat-menu
                #listRequiredFilterDropDownMenu="matMenu"
                class="st-filter-add-menu">
                <ng-template matMenuContent>
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateRequiredFiltersIDs()"
                        (selectionChange)="onFilterStateChange($event, true)">
                        @for (item of viewStateAllFilters(); track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && item.IsOptional"
                                [value]="item.ID"
                                [dir]="isRTL">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </ng-template>
            </mat-menu>
        }
        @if (filterType === filterTypes.OPTIONAL) {
            <button
                mat-raised-button
                class="st-filter-add"
                [matMenuTriggerFor]="listOptionalFilterDropDownMenu"
                [disabled]="isViewStateSortingManual()">
                {{ `+ ${languageSettings.PSTWebAddFilterLabel}` }}
            </button>
            <mat-menu
                #listOptionalFilterDropDownMenu="matMenu"
                class="st-filter-add-menu">
                <ng-template matMenuContent>
                    <mat-selection-list
                        st-click-stop-propagation
                        [ngModel]="viewStateOptionalFiltersIDs()"
                        (selectionChange)="onFilterStateChange($event, false)">
                        @for (item of viewStateAllFilters(); track item.ID) {
                            <mat-list-option
                                [disabled]="!item.NotUsed && item.IsRequired"
                                [value]="item.ID"
                                [dir]="isRTL">
                                {{ item.DefaultCaption }}
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </ng-template>
            </mat-menu>
        }
    </div>
}

@if (isManageTeamMembers()) {
    <div class="st-filter-body">
        <mat-button-toggle-group
            name="filterType"
            aria-label="Type"
            class="st-filter-full-width"
            [(ngModel)]="filterType">
            <mat-button-toggle
                class="st-filter-full-width-button-toggle"
                [value]="filterTypes.REQUIRED">
                @if (filterType === filterTypes.REQUIRED) {
                    <mat-icon class="material-symbols-outlined">check</mat-icon>
                }
                {{ languageSettings.PSTWebRequiredFiltersLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-filter-full-width-button-toggle"
                [value]="filterTypes.OPTIONAL">
                @if (filterType === filterTypes.OPTIONAL) {
                    <mat-icon class="material-symbols-outlined">check</mat-icon>
                }
                {{ languageSettings.PSTWebOptionalFiltersLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>
        <st-filter-manage-team-members [type]="filterType" />
    </div>
}

@if (isPlanningViews()) {
    <div class="st-filter-body">
        <st-filter-planning-views />
    </div>
}
